import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './Dashboard.css';
// import { logout } from '../api/auth/authService';
import { AuthContext } from '../contexts/AuthContext';
import { useContext } from 'react';
function Sidebar() {
    const [sidebarActive, setSidebarActive] = useState(false);

    const openSidebar = () => setSidebarActive(true);
    const closeSidebar = () => setSidebarActive(false);

    useEffect(() => {
        if (sidebarActive) {
            document.body.classList.add('sidebar-open');
        } else {
            document.body.classList.remove('sidebar-open');
        }
    }, [sidebarActive]);
    const { logout } = useContext(AuthContext);


    const handleLogoutClick = async (e) => {
        e.preventDefault();
        try {
            const result = await logout();
            console.log("Logout success:", result);
        } catch (err) {
            console.error("Logout error in component:", err);
        }

    };
    return (
        <div>
            {/* Overlay */}
            <div
                id="sidebar-overlay"
                className={`overlay w-100 vh-100 position-fixed ${sidebarActive ? '' : 'd-none'}`}
                onClick={closeSidebar}
            ></div>

            {/* Sidebar */}
            <div
                className={`col-md-3 col-lg-2 px-0 position-fixed h-100 bg-white shadow-sm sidebar ${sidebarActive ? 'active' : ''}`}
                id="sidebar"
            >
                <h1>

                    <img src="/img/Webnet-Logo.png" alt="Logo" className="logo" style={{ width: '100%', height: '50px' }} />
                </h1>
                <div className="list-group rounded-0 mt-2">

                    <a href="/dashboard" className="list-group-item list-group-item-action active border-0 d-flex align-items-center">
                        <span className="bi bi-border-all"></span>
                        <span className="ms-2">Dashboard</span>
                    </a>

                    {/* Home Page */}
                    <div>
                        <button
                            className="list-group-item list-group-item-action border-0 d-flex justify-content-between align-items-center"
                            data-bs-toggle="collapse"
                            data-bs-target="#home-collapse"
                        >
                            <div>
                                <span className="bi bi-cart-dash"></span>
                                <span className="ms-2">Home Page</span>
                            </div>
                            <span className="bi bi-chevron-down small"></span>
                        </button>
                        <div className="collapse" id="home-collapse">
                            <div className="list-group">
                                <a href="/Sliderupdate" className="list-group-item list-group-item-action border-0 ps-5">Slider</a>
                                <a href="/testimonialupdate" className="list-group-item list-group-item-action border-0 ps-5">Testimonial</a>
                                <a href="/portfolioupdate" className="list-group-item list-group-item-action border-0 ps-5">Portfolio</a>
                                <a href="/Teamupdate" className="list-group-item list-group-item-action border-0 ps-5">Our Team</a>
                            </div>
                        </div>
                    </div>

                    {/* Pricing */}
                    <div>
                        <button
                            className="list-group-item list-group-item-action border-0 d-flex justify-content-between align-items-center"
                            data-bs-toggle="collapse"
                            data-bs-target="#sale-collapse"
                        >
                            <div>
                                <span className="bi bi-cart-dash"></span>
                                <span className="ms-2">Pricing</span>
                            </div>
                            <span className="bi bi-chevron-down small"></span>
                        </button>
                        <div className="collapse" id="sale-collapse">
                            <div className="list-group">
                                <a href="/clinicsolutionupdate" className="list-group-item list-group-item-action border-0 ps-5">Plan Type</a>
                                {/* <a href="/pricing" className="list-group-item list-group-item-action border-0 ps-5">Pricing</a> */}
                                <a href="/plan" className="list-group-item list-group-item-action border-0 ps-5">Plan Details</a>

                                <a href="/otherproductdetails" className="list-group-item list-group-item-action border-0 ps-5">Other Product</a>
                            </div>
                        </div>
                    </div>

                    {/* Resources */}
                    <div>
                        <button
                            className="list-group-item list-group-item-action border-0 d-flex justify-content-between align-items-center"
                            data-bs-toggle="collapse"
                            data-bs-target="#purchase-collapse"
                        >
                            <div>
                                <span className="bi bi-cart-plus"></span>
                                <span className="ms-2">Resources</span>
                            </div>
                            <span className="bi bi-chevron-down small"></span>
                        </button>
                        <div className="collapse" id="purchase-collapse">
                            <div className="list-group">
                                <a href="/category" className="list-group-item list-group-item-action border-0 ps-5">Blog Category</a>
                                <a href="/blogsupdate" className="list-group-item list-group-item-action border-0 ps-5">Blogs</a>
                                <a href="/faqsupdate" className="list-group-item list-group-item-action border-0 ps-5">FAQs</a>
                            </div>
                        </div>
                    </div>

                    {/* Static Links */}

                    <a href="/ClientLogo" className="list-group-item list-group-item-action border-0 align-items-center">
                        <span className="bi bi-box"></span>
                        <span className="ms-2">Client Logo</span>
                    </a>

                    <a href="/bookappoinmentdetail" className="list-group-item list-group-item-action border-0 align-items-center">
                        <span className="bi bi-box"></span>
                        <span className="ms-2">Book Appointment</span>
                    </a>

                    <a href="/contactusdetails" className="list-group-item list-group-item-action border-0 align-items-center">
                        <span className="bi bi-box"></span>
                        <span className="ms-2">Contact Us</span>
                    </a>


                    <a href="/clientenquiry" className="list-group-item list-group-item-action border-0 align-items-center">
                        <span className="bi bi-box"></span>
                        <span className="ms-2"> Enquiry</span>
                    </a>

                    <a href="/Booknowdetails" className="list-group-item list-group-item-action border-0 align-items-center">
                        <span className="bi bi-box"></span>
                        <span className="ms-2">Book Now</span>
                    </a>
                </div>
            </div>
            {/* Main content */}
            <div className="col-md-9 col-lg-10 ms-md-auto px-0">
                {/* Top nav */}
                <nav className="w-100 d-flex px-4 py-2 mb-4 shadow-sm">
                    <button className="btn py-0 d-lg-none" onClick={openSidebar}>
                        <span className="bi bi-list text-primary h3"></span>
                    </button>
                    <div className="dropdown ms-auto">
                        <button
                            className="btn py-0 d-flex align-items-center"
                            id="logout-dropdown"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            <span className="bi bi-person  h4" style={{ padding: '5px' }}></span>
                            <span className="bi bi-chevron-down ms-1 mb-2 small"></span>
                        </button>
                        <div className="dropdown-menu dropdown-menu-end border-0 shadow-sm"
                            aria-labelledby="logout-dropdown"
                        >
                            <button className="dropdown-item" onClick={handleLogoutClick}>
                                Logout
                            </button>

                            <a className="dropdown-item" href="/settings">
                                Settings
                            </a>
                        </div>

                    </div>
                </nav>

            </div>
        </div>
    );
}

export default Sidebar;
